export default __webpack_public_path__ + "static/media/avatar-normal-geometric-12.b9b806b7.svg";